import React from 'react';
import type { Position } from '~/common/recorder/recorder-operation';

const PositionPart = ({ position }: { position: Position }) => {
  return (
    <p>
      <span>at position </span>
      <span>
        ({position.x.toFixed()}, {position.y.toFixed()})
      </span>
    </p>
  );
};

export default PositionPart;
